module.exports = __webpack_public_path__ + "static/img/VernierCaliper01.9c59166.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Buy/VernierCaliper/VernierCaliper01.png
// module id = +0+9
// module chunks = 12